import { FC } from 'react';
import ReactDOM from 'react-dom';

export const TitleContainer: FC = () => {
  return (
    <div>
      <span
        className="text-[2.8rem] h-[3.4rem] leading-[2rem] font-extrabold font-montserrat uppercase"
        id="header-title-container"
      />
    </div>
  );
};

interface TitleProps {
  pageTitle?: React.ReactNode;
}

export const Title: FC<TitleProps> = ({ pageTitle = '' }) => {
  const node = document.getElementById('header-title-container');

  return node ? ReactDOM.createPortal(pageTitle, node) : <></>;
};
